import isEmpty from 'lodash/isEmpty';
import { createFrozenMap } from '@/vuex/utils';
import { fetchMetaGroups } from './meta-groups.utils';
import { localizeMetaGroups } from './meta-groups.utils';

const metaGroups = {
    namespaced: true,
    state: {
        map: {},
        fetching: false,
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        async loadAll ({ commit, state }, { reFetch = false, items = true } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            commit('setFetching', { fetching: true });

            try {
                const { data: metaGroups } = await fetchMetaGroups({ items });
                const localizedMetaGroups = localizeMetaGroups(metaGroups);
                commit('setFetching', { fetching: false });
                commit('setMap', {
                    map: createFrozenMap(localizedMetaGroups),
                });
            } catch (error) {
                commit('setFetching', { fetching: false });
                commit('setError', { error });
                throw error;
            }
        },
    },
    getters: {
        list: (state) => Object.values(state.map),
    },
};

export default metaGroups;
